<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
    import {sgettext} from '../../i18n.js';
    import {get} from '../../utils.js';
    import Errors from '../Errors.svelte';
    import InfoTooltip from '../common/InfoTooltip.svelte';

    let workCentreId = 0;
    let work_centre_element = document.getElementById("id_work_centre");
    let emails = [];
    let formErrors = "";

    $: emailGroupUserListUrl = `${PATH_PREFIX}/old/sw/administration/user-email-groups/work-centre/${workCentreId}`

    let mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.target === work_centre_element) {
                workCentreId = work_centre_element.dataset.workCentre;
            }
        });
    });

    mutationObserver.observe(document.getElementById("id_work_centre"), {
        attributes: true,
    });

    async function getEmailGroupUsersForWorkCentre(url) {
        if (!workCentreId) {
            emails = [];
            return;
        }

        try {
            const response = await get(url);
            if (response.ok) {
                const res = await response.json();
                emails = res.emails;
            } else {
                const err = await response.json();
                if (err.hasOwnProperty('error')) {
                    formErrors = err.error;
                }
            }
        }
        catch(err) {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_FETCHING_EMAIL$$');
        }
    }

    $: getEmailGroupUsersForWorkCentre(emailGroupUserListUrl);
</script>

<div>
  <div class="mt-3">
    <Errors errors={formErrors} />
  </div>
  <label
    >{sgettext('$$EMAIL_RECIPIENTS_SUMMARY_REPORTS$$')}
    <InfoTooltip
      tooltipText={sgettext(
        '$$UPON_COMPLETION_INSTANCE_FOLLOWING_EMAIL$$'
      )}
    />
  </label>
  <p class="secondary-label text-secondary mb-0">
    {sgettext('$$CONFIGURED_MAIN_WORK_CENTRE_1$$').toUpperCase()}
    <InfoTooltip
      tooltipText={sgettext(
        '$$FOLLOWING_EMAILS_CONFIGURED_SYSTEM_ADMIN$$'
      )}
    />
  </p>
  <div class="user-list mr-1 pl-3">
    {#if emails.length}
      {#each emails as email}
        <p class="my-2">{email}</p>
      {/each}
    {:else if workCentreId == ''}
      <p class="my-2 text-secondary">
        <b>{sgettext('$$SELECT_MWC_SEE_EMAIL_RECIPIENTS$$')}</b>
      </p>
    {:else}
      <p class="my-2 text-secondary">
        <b>{sgettext('$$EMAIL_RECIPIENTS_CONFIGURED$$')}</b>
      </p>
    {/if}
  </div>
</div>

<div>
  <div class="mt-3">
    <Errors errors={formErrors} />
  </div>
  <label
    >{sgettext('$$EMAIL_RECIPIENTS_SUMMARY_REPORTS$$')}
    <InfoTooltip
      tooltipText={sgettext(
        '$$UPON_COMPLETION_INSTANCE_FOLLOWING_EMAIL$$'
      )}
    />
  </label>
  <p class="secondary-label text-secondary mb-0">
    {sgettext('$$CONFIGURED_MAIN_WORK_CENTRE_1$$').toUpperCase()}
    <InfoTooltip
      tooltipText={sgettext(
        '$$FOLLOWING_EMAILS_CONFIGURED_SYSTEM_RAISE$$'
      )}
    />
  </p>
  <div class="user-list mr-1 pl-3">
    {#if emails.length}
      {#each emails as email}
        <p class="my-2">{email}</p>
      {/each}
    {:else if workCentreId == ''}
      <p class="my-2 text-secondary">
        <b>{sgettext('$$SELECT_MWC_SEE_EMAIL_RECIPIENTS$$')}</b>
      </p>
    {:else}
      <p class="my-2 text-secondary">
        <b>{sgettext('$$EMAIL_RECIPIENTS_CONFIGURED$$')}</b>
      </p>
    {/if}
  </div>
</div>

<style>
  .user-list {
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #eee;
    min-height: 100px;
    max-height: 150px;
    overflow-y: scroll;
  }

  .secondary-label {
    letter-spacing: 1px !important;
    font-size: 0.9rem;
  }
</style>
